// @ts-nocheck
export const SEARCH_PARAMS = [
	{
		value: 1,
		rowIdentifier: 'AdType',
		displayName: 'Ad Type',
	},
];

export const TABLE_ID = 45;

// @ts-nocheck
export const TABS_IDENTIFIER = {
	UPCOMING: 'UPCOMING',
	PAST: 'PAST',
	ALL: 'ALL',
};

export const DEFAULT_TABS = [
	{
		title: 'Upcoming',
		type: TABS_IDENTIFIER.UPCOMING,
	},
	{
		title: 'Past',
		type: TABS_IDENTIFIER.PAST,
	},
	{
		title: 'All',
		type: TABS_IDENTIFIER.ALL,
	},
];

export const STORE_PREFIX = 'items';

export const MENU_ITEMS_NAMES = {
	CUSTOMIZE_VIEW: 'Customize View',
	RESET_VIEW: 'Reset View',
};

export const MENU_ITEMS_VALUES = {
	CUSTOMIZE_VIEW: 'CUSTOMIZE_VIEW',
	RESET_VIEW: 'RESET_VIEW',
};

export const MENU_ITEMS = [
	{
		displayName: MENU_ITEMS_NAMES.CUSTOMIZE_VIEW,
		value: MENU_ITEMS_VALUES.CUSTOMIZE_VIEW,
	},
	{
		displayName: MENU_ITEMS_NAMES.RESET_VIEW,
		value: MENU_ITEMS_VALUES.RESET_VIEW,
	},
];
